// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"a3455c93","275":"b606bb43","461":"9c409b27","891":"0d4d5388"}[chunkId] + ".css";
};